<app-background-image data-state="sustainability"></app-background-image>
<app-topbar></app-topbar>


<app-sidebar class="d-print-none">
    <div class="sidebar-header"></div>
    <ul class="nav flex-column navbar-nav">
        <li class="d-grid gap-2">
            <button class="btn btn-outline-primary btn-block" (click)="back()">
                <fa-icon [icon]="faBack"></fa-icon>
                <span style="padding-left: 10px">Back</span>
            </button>
        </li>
    </ul>
</app-sidebar>
<ng-container *ngIf="{ edit: showEditor } as editor">
    <div class="main-content" [ngClass]="{ 'editor-show': editor.edit }">


        <div id="esgdata-table">
            <div class="table-container">
                <div class="main-content-header">
                    <h3 id="storageitemdetails-header">ESG report</h3>
                </div>

            <div *ngIf="mapObservable(esgList, isLoading) | async">
                Loading...
            </div>
            <div *ngIf="mapObservable(esgList, isEmpty) | async">
                No ESG items yet.
            </div>
            <div *ngIf="mapObservable(esgList, isLoaded) | async">
                <table class="table table-striped table-hover">
                    <colgroup>
                        <col style="width: auto" />
                        <col style="width: 80px" />
                    </colgroup>

                    <thead>
                        <tr>
                            <th
                                scope="col"
                                sortable="year"
                                [direction]="getSortDirection('year')"
                                (sort)="onSort($event)"
                            >
                                Year
                                <fa-icon
                                    *ngIf="
                                        getSortDirectionIcon('year');
                                        else sortNone
                                    "
                                    [icon]="getSortDirectionIcon('year')"
                                ></fa-icon>
                            </th>
                            <th scope="col"><!--Edit--></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let esg of esgList | async">
                            <td (click)="edit(esg)">{{ esg.year }}</td>
                            <td>
                                <button
                                    class="btn btn-sm btn-secondary float-right"
                                    type="button"
                                    (click)="edit(esg)"
                                >
                                    Edit
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div style="display: flex">
                <button
                    type="button"
                    (click)="add()"
                    class="btn btn-primary btn-sm"
                >
                    Create ESG report...
                </button>
            </div>
        </div>
        </div>
        <div id="esg-editor">
            <form
                *ngIf="showEditor"
                class="esg-details"
                [formGroup]="esgForm"
                (ngSubmit)="onEsgFormSubmit()"
            >
                <div class="card">
                    <div class="card-header">{{ cardHeader }}</div>
                    <div class="card-body">
                        <table class="form-table">
                            <tbody>
                                <tr>
                                    <td>
                                        <label for="year">Year</label>
                                    </td>
                                    <td>
                                        <select
                                            class="form-control"
                                            formControlName="year"
                                            [ngClass]="{
                                                'is-invalid':
                                                    (esgForm.controls.year
                                                        .touched ||
                                                        esgForm.controls.year
                                                            .dirty) &&
                                                    !esgForm.controls.year
                                                        .valid,
                                                'is-valid':
                                                    esgForm.controls.year.valid
                                            }"
                                        >
                                            <option [value]="null" disabled>
                                                Select a year
                                            </option>
                                            <option
                                                [value]="year"
                                                *ngFor="let year of yearList"
                                            >
                                                {{ year }}
                                            </option>
                                        </select>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <ul
                            ngbNav
                            #nav="ngbNav"
                            class="nav nav-tabs nav-tabs-bottom sticky-footer"
                        >
                            <li
                                ngbNavItem="scope1"
                                [disabled]="esgForm.invalid || !inputValid"
                            >
                                <a ngbNavLink>Scope 1</a>
                                <ng-template ngbNavContent>
                                    <app-sustainability-esg-scope
                                        [scopeNumber]="1"
                                        (formIsValid)="scopeFormValid($event)"
                                        [esgSelected]="esgSelected"
                                        (scopeData)="scopeDataUpdated($event)"
                                        (formIsValid)="scopeFormIsDirty($event)"
                                    ></app-sustainability-esg-scope>
                                </ng-template>
                            </li>
                            <li
                                ngbNavItem="scope2"
                                [disabled]="esgForm.invalid || !inputValid"
                            >
                                <a ngbNavLink>Scope 2</a>
                                <ng-template ngbNavContent>
                                    <app-sustainability-esg-scope
                                        [scopeNumber]="2"
                                        (formIsValid)="scopeFormValid($event)"
                                        [esgSelected]="esgSelected"
                                        (scopeData)="scopeDataUpdated($event)"
                                        (formIsValid)="scopeFormIsDirty($event)"
                                    ></app-sustainability-esg-scope>
                                </ng-template>
                            </li>
                            <li
                                ngbNavItem="scope3"
                                [disabled]="esgForm.invalid || !inputValid"
                            >
                                <a ngbNavLink>Scope 3</a>
                                <ng-template ngbNavContent>
                                    <app-sustainability-esg-scope
                                        [scopeNumber]="3"
                                        (formIsValid)="scopeFormValid($event)"
                                        [esgSelected]="esgSelected"
                                        (scopeData)="scopeDataUpdated($event)"
                                        (formIsValid)="scopeFormIsDirty($event)"
                                    ></app-sustainability-esg-scope>
                                </ng-template>
                            </li>
                            <li
                                ngbNavItem="scope4"
                                [disabled]="esgForm.invalid || !inputValid"
                            >
                                <a ngbNavLink>Out of scope</a>
                                <ng-template ngbNavContent>
                                    <app-sustainability-esg-scope
                                        [scopeNumber]="4"
                                        (formIsValid)="scopeFormValid($event)"
                                        [esgSelected]="esgSelected"
                                        (scopeData)="scopeDataUpdated($event)"
                                        (formIsValid)="scopeFormIsDirty($event)"
                                    ></app-sustainability-esg-scope>
                                </ng-template>
                            </li>
                        </ul>
                        <div [ngbNavOutlet]="nav"></div>
                    </div>
                    <div class="card-footer">
                        <div class="btn-group float-right">
                            <button
                                class="btn btn-danger"
                                type="button"
                                *ngIf="!newEsg"
                                (click)="delete()"
                            >
                                Delete
                            </button>
                            <button
                                type="submit"
                                class="btn btn-primary"
                                [disabled]="esgForm.invalid || !inputValid"
                            >
                                Update
                            </button>
                            <button type="button" class="btn btn-outline-secondary" (click)="cancel()">
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</ng-container>
<ng-template #sortNone>
    <div style="width: 16px; height: 21px; display: inline-block"></div>
</ng-template>
